var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SelectorMain", {
    ref: "selectorMain",
    attrs: { selected: _vm.selected },
    on: { change: _vm.selectedChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }